const GLOBAL_KEY = 'DJsdfg-2352LLDSF-dfg-jsah33454-//4415gfsfd-WEB-FOX'

/**
 * Devuelve una configuración de persistencia personalizada
 * que guarda cada módulo dentro de una clave global compartida.
 * @param {string} moduleKey - nombre del store
 */
export function createPersistConfig(moduleKey) {
  return {
    key: GLOBAL_KEY,
    storage: localStorage,
    serializer: {
      serialize: (value) => {
        const data = JSON.parse(localStorage.getItem(GLOBAL_KEY) || '{}')
        data[moduleKey] = value
        return JSON.stringify(data)
      },
      deserialize: (value) => {
        const data = JSON.parse(value)
        return data[moduleKey] || {}
      },
    },
  }
}

export { GLOBAL_KEY }